import script from "./OtherService.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherService.vue?vue&type=script&setup=true&lang=js"

import "./OtherService.vue?vue&type=style&index=0&id=78d02555&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d02555"]])

export default __exports__